import { message, notification } from 'ant-design-vue';
export const TipsStyle = {
  Msg: 'msg',
  Notify: 'ntf',
  Confirm: 'cf'
  // Custom: 'custom',
};

export const TipsStyleText = {
  [TipsStyle.Msg]: '消息提示',
  [TipsStyle.Notify]: '通知浮层',
  [TipsStyle.Confirm]: '确认框'
};
class WujiTips {
  constructor(projectInfo, vueIns) {
    this.project = projectInfo || window.xy_runtime_project;
    this.vueIns = vueIns || window.xy_vue_instance;
  }
  get tipsStyle() {
    var _this$project;
    return (_this$project = this.project) === null || _this$project === void 0 || (_this$project = _this$project.uiInfo) === null || _this$project === void 0 ? void 0 : _this$project.tipsStyle;
  }
  get vm() {
    return this.vueIns || window.xy_vue_instance || {};
  }
  tips(levelFnStr, options = {
    title: '',
    content: ''
  }) {
    const fn = this.vm[`$${levelFnStr}`] || this.vm.$confirm;
    const finalOptions = typeof options === 'string' ? {
      title: levelFnStr,
      content: options
    } : options;
    const renderContent = content => h => {
      const props = {
        style: {
          color: 'rgba(0, 0, 0, 0.65)',
          'white-space': 'pre-line',
          'margin-bottom': 0,
          'word-break': 'break-all'
        }
      };
      return h('p', props, content);
    };
    // const dom = <span style={{ fontSize: '12px' }}>{finalOptions.content}</span>;
    switch (this.tipsStyle) {
      case TipsStyle.Confirm:
        if (typeof fn === 'function') {
          return fn.call(this.vm, {
            title: finalOptions.title,
            content: finalOptions.content
          });
        }
        return message[levelFnStr].call(null, finalOptions.content, finalOptions.duration);
      // confirm 会用 message 兜底
      case TipsStyle.Msg:
        return message[levelFnStr].call(null, finalOptions.content, finalOptions.duration);
      case TipsStyle.Notify:
      default:
        // 无 title 时只展示 content
        return notification[levelFnStr].call(null, {
          description: finalOptions.title ? renderContent(finalOptions.content) : () => '',
          message: finalOptions.title ? finalOptions.title : renderContent(finalOptions.content),
          style: {
            'max-height': '90vh',
            overflow: 'auto'
          }
        });
    }
  }
}
const tipMethodNames = ['success', 'info', 'warn', 'warning', 'error'];
tipMethodNames.forEach(fnName => {
  WujiTips.prototype[fnName] = function (opts = {
    title: '',
    content: ''
  }) {
    return this.tips(fnName, opts);
  };
});
const tipsOptionSchema = {
  id: 'wujiTipsOptions',
  type: 'object',
  fields: [{
    id: 'title',
    type: 'string',
    required: true,
    title: '标题'
  }, {
    id: 'content',
    type: 'string',
    required: true,
    title: '提示内容'
  }, {
    id: 'duration',
    type: 'number',
    required: false,
    title: '默认自动关闭延时，单位秒'
  }]
};
export const wujiTipsSchema = {
  id: '$tips',
  type: 'object',
  title: '统一的消息提示API',
  readonly: true,
  hidden: true,
  methods: tipMethodNames.map(name => {
    const m = {
      id: name,
      arguments: [tipsOptionSchema]
    };
    return m;
  })
};
export default WujiTips;
//# sourceMappingURL=wujiTips.js.map
